export const getOffers = state => state.plans.offers;
